import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { Slide } from 'pure-react-carousel';
import CarouselSlider from 'components/atoms/TemplateCarouselSlider';
/**
 * ListImageCard :: Extension of Large_CardDefault
 */
const domainUrlParam = process.env.REACT_APP_DOMAIN_URL;

const ListImageCard = ({ boxStyle, item, viewType, onClickEvt, tabIndex }) => {
  const { items } = item;
  const slideBoxSet = boxStyle;
  const slideBoxSetStyle = {
    // width: `${slideBoxSet.width}px`,
    // height: slideBoxSet.height,
    width: '270px',
    height: '430px',
    margin: `0 ${slideBoxSet.margin}px`,
  };
  const slideLength = items.length;
  const constentSet = () => {
    return (
      <>
        {items.map((tempItem, idx) => {
          let htmlCheck = false;
          if (!tempItem.image_btn.image.includes('<img')) {
            htmlCheck = true;
          }

          let contentImage;
          if (htmlCheck) {
            contentImage = <img src={tempItem.image_btn.image} alt={tempItem.image_btn.label} />;
          } else {
            contentImage = <div>{ReactHtmlParser(tempItem.image_btn.image)}</div>;
          }

          const tempImage = tempItem.image_btn.image ? contentImage : <img src={`/${domainUrlParam}/ibricks/images/noimage.png`} alt="noimage" />;

          return (
            <Slide key={`slide_${idx}`} index={idx} className="_image_card" style={slideBoxSetStyle}>
              <div className="image_box" tabIndex={tabIndex}>
                <div className="_cont_image" onClick={e => onClickEvt(tempItem.image_btn.value, tempItem.image_btn.action)}>
                  <div className="_image_box">
                    {tempImage}
                    {/* <img src={tempItem.image.image} alt={tempItem.image.alt} /> */}
                  </div>
                </div>
                <div className="_label_box">
                  <div className="_label">{ReactHtmlParser(tempItem.image_btn.label)}</div>
                </div>
                <div className="_desc_box">
                  <div className="_desc">{ReactHtmlParser(tempItem.text.desc)}</div>
                </div>
              </div>
            </Slide>
          );
        })}
      </>
    );
  };
  return (
    <>
      <div className="_carousel_button_div">
        <CarouselSlider slideBoxSet={slideBoxSet} contentCount={slideLength} contentSet={constentSet} />
      </div>
    </>
  );
};
ListImageCard.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  onClickEvt: PropTypes.func,
  tabIndex: PropTypes.string,
};
ListImageCard.defaultProps = {
  boxStyle: { width: 150, margin: 10, height: '220px' },
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
  onClickEvt: null,
  tabIndex: '0',
};

export default ListImageCard;
